export const isObject = (value) => !Array.isArray(value) && value === Object(value);
